import React from "react";
import { Box, Typography, Button, Stack, Grid } from "@mui/material";
import FlashOnIcon from "@mui/icons-material/FlashOn";

const WhatsBusinessAPI = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        backgroundImage: `url('bg3.svg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 10 },
          py: { xs: 4, sm: 6, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Grid container alignItems="center" spacing={4}>
          {/* Text Section */}
          <Grid item xs={12} md={8}>
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              sx={{
                fontSize: { xs: "2rem", md: "3rem" },
                lineHeight: 1.2,
                color: "rgb(255,255,255)",
              }}
            >
              Drive 3x Revenue with{" "}
              <span style={{ fontWeight: 600 }}>Vertex Suite</span>
            </Typography>

            <Typography
              variant="subtitle1"
              sx={{
                mt: 2,
                fontSize: {
                  xs: "1.2rem",
                  md: "1.2rem",
                },
                color: "rgba(255, 255, 255, 0.7)",
              }}
            >
              Get Started for FREE. No Credit Card needed.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 1.5,
                fontSize: { xs: "1.05rem", md: "1.15rem" },
                color: "rgba(255, 255, 255, 0.7)",
              }}
            >
              <FlashOnIcon
                sx={{ fontSize: "1.4rem", color: "#ff9100", mr: 1 }}
              />
              Powered by{" "}
              <strong style={{ marginLeft: 4 }}>
                Official WhatsApp Business API
              </strong>
            </Typography>
          </Grid>

          {/* Button Section */}
          <Grid item xs={12} md={4}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent={{ xs: "flex-start", md: "flex-end" }}
              mt={{ xs: 4, md: 0 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#00C851",
                  color: "#fff",
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#00b34a",
                  },
                }}
              >
                Start for FREE →
              </Button>
              <Button
                variant="outlined"
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.7)",
                  color: "rgba(255, 255, 255, 0.8)",
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: 600,
                  "&:hover": {
                    backdropFilter: "blur(10px)",
                    boxShadow: 2,
                  },
                }}
              >
                Book a Demo →
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default WhatsBusinessAPI;
